import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import SensorsIcon from '@mui/icons-material/Sensors';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';

// import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  emptyCellOneLevel,
  gridSizeMdLg12,
  gridSizeMdLg3,
  gridSizeMdLg6,
  useLoaders,
  // hasAllPermissions,
  // useCheckPermissions,
} from "@/shared";
import { useFetchClientesMigradosAll, usePostActivacionesRadius, useUpdateClientesMigrados, useUpdateContrato } from "@/shared/actions/erp";
import {
  CustomAutocompleteArrStringNoForm,
  // CustomAutocompleteMultipleSelect,
  CustomSearch,
  GeneralTable,
  SingleIconButton,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useTableFilter } from "@/shared/hooks/useTableFilter";
import { ClientesMigrados, Contrato, EstadosNavegacionEnum } from "@/shared/interfaces";
import { useUiConfirmModalStore } from "@/store/ui";
import { Button, Chip, Grid } from "@mui/material";
import { CHOICES_TIPOFILTROACTSERVICIOCLIENTE, TipoFiltroActServicioCliente } from "../../shared";
import { Info } from "@mui/icons-material";
import DetallesDeConsumoClienteModal from "../../shared/components/DetallesDeConsumoClienteModal";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

// import { SAVE_SERVICIO_CLIENTE_PERMISSIONS } from "../../shared/constants";

export enum EstadoServicioSoftnet {
  CLIENTE_ACTIVO="Clientes Activos",
  SERVICIO_SUSPENDIDO="Servicio Suspendido",
  EQUIPOS_RETIRADOS="Equipos Retirados",
  EQUIPOS_POR_RETIRAR="Equipos por Retirar",
  EQUIPOS_COBRADOS="Equipos Cobrados",
  SOLICITUD_CANCELACION="Solicitud de Cancelacion",
  EN_PROCESO_RETIRO="En Proceso de Retiro"
}

export type ActualizarServicioClientePageMainProps = {};

// type ClienteContrato = {
//   id_contrato: string;
//   razon_social: string;
// }

const ActualizarServicioClientePageMain: React.FC<ActualizarServicioClientePageMainProps> = () => {
  // useCheckPermissions(PermissionsEnum.api_view_olt);

  const returnUrlActualizarServicioClientePageMain = ROUTER_PATHS.activaciones.activacionActServicioClientesNav;

  // const [bulkChangeState, setBulkChangeState] = useState<string[]>([]);
  // const [dataBulkSelected, setDataBulkSelected] = useState<ClienteContrato[]>([]);
  const [estadoNavegacionRequerido, setEstadoNavegacionRequerido] = useState<string>("");
  const [refetchBulk, setRefetchBulk] = useState<boolean>(false);
  const [rowSelection, setRowSelection] = useState<any>({});
  const [openModalDetailsRReply, setopenModalDetailsRReply] = useState(false);
  const [currentRad, setCurrentRad] = useState<ClientesMigrados | null>(null);
  const [tipoFiltro, setTipoFiltro] = useState<TipoFiltroActServicioCliente>(TipoFiltroActServicioCliente.IDENTIFICACION);

  const ChoicesEstadosNavegacionEnum = [
    EstadosNavegacionEnum.SUSPENDIDO,
    EstadosNavegacionEnum.ACTIVO,
  ]

  

  const navigate = useNavigate();

  ///* global state
  const queryClient = useQueryClient();
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: ClientesMigradosPagingRes,
    isLoading,
    isRefetching,
  } = useFetchClientesMigradosAll(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      razon_social: tipoFiltro === TipoFiltroActServicioCliente.RAZON_SOCIAL ? searchTerm : undefined,
      identificacion: tipoFiltro === TipoFiltroActServicioCliente.IDENTIFICACION ? searchTerm : undefined,
      pppoe: tipoFiltro === TipoFiltroActServicioCliente.PPPOE ? searchTerm : undefined,
    },
    ((tipoFiltro === TipoFiltroActServicioCliente.RAZON_SOCIAL) && searchTerm.length > 5) 
    || ((tipoFiltro === TipoFiltroActServicioCliente.IDENTIFICACION)
    && (searchTerm.length == 10 || searchTerm.length == 13))
    || ((tipoFiltro === TipoFiltroActServicioCliente.PPPOE)
    && (searchTerm.length > 6)),
  );
  
  const {
    mutateAsync:CambiarEstadoNavegacion
  } = useUpdateContrato<Pick<Contrato,"id_contrato"|"estado_navegacion">>({
    enableRedirect:false,
    enableSuccessAlert:false
  })
  const {
    mutateAsync: postActivacionesRadius,
    isPending: pendingActivacionesRadius,
  } = usePostActivacionesRadius({
    customSuccessMessage:"Registro actualizado correctamente",
    customMessageErrorAlert:"Error al actualizar el registro, por favor, intente nuevamente."
  })

  const { 
      mutateAsync: updateContrato,
      // isPending: pendingContratoUpdate
  } = useUpdateContrato<Pick<Contrato,"estado_navegacion">>()
  const { 
      mutateAsync: updateClienteMigrado,
      // isPending: pendingContratoUpdate
  } = useUpdateClientesMigrados({
    enableRedirect:false,
    enableSuccessAlert:false
  })

  ///* handlers

  const onEdit = (cliente: ClientesMigrados) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar Servicio de Cliente",
      subtitle: "¿Está seguro que desea actualizar la configuración de este cliente?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrlActualizarServicioClientePageMain}/actualizar/${cliente.contrato_data?.id_contrato}`);
      },
    });
  };

  // const onDelete = (olt: OLT) => {
  //   setConfirmDialog({
  //     isOpen: true,
  //     title: "Eliminar OLT",
  //     subtitle: "¿Está seguro que desea eliminar este OLT?",
  //     onConfirm: () => {
  //       setConfirmDialogIsOpen(false);
  //       deleteOLT.mutate(olt.id_olt!);
  //     },
  //   });
  // };

  const columns = useMemo<MRT_ColumnDef<ClientesMigrados>[]>(
    () => [
      {
        accessorKey: "identificacion",
        header: "Identificación",
        size: 180,
        Cell: ({ row }) => row.original?.cliente_data?.identificacion||"N/A"
      },
      {
        accessorKey: "nombre",
        header: "Nombre",
        size: 180,
        Cell: ({ row }) => row.original?.cliente_data?.razon_social||"N/A"
      },
      {
        accessorKey: "linea",
        header: "Línea de Servicio",
        size: 180,
        Cell: ({ row }) => row.original?.contrato_data?.linea||"N/A"
      },
      {
        accessorKey: "numero_contrato",
        header: "Número de Contrato",
        size: 180,
        Cell: ({ row }) => row.original?.numero_referencia||"N/A"
      },
      {
        accessorKey: "pppoe",
        header: "PPPoE",
        size: 180,
        Cell: ({ row }) => row.original?.pppoe || "N/A"
      },
      {
        accessorKey: "ipv4",
        header: "IPv4",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "ipv4"),
      },
      {
        accessorKey: "estado_servicio",
        header: "Estado de Servicio",
        size: 180,
        Cell: ({ row }) => <Chip 
          label={row.original?.estado_servicio||""} 
          color={row.original?.estado_servicio==EstadoServicioSoftnet.CLIENTE_ACTIVO?
            "success"
            :"error"
          } 
          variant="filled" />
      },
    ],
    []
  );

  
  //CUSTOM HOOKS
  useEffect(() => {
    // =========================================================================
    // para permitir el refetch de datos
    // =========================================================================
    setTimeout(() => {
      setRefetchBulk(false)
    }, 200);
  }, [refetchBulk]);


  // const { fileInputRef: importOLTs, handleImportarOLT } = useUploadFile();
  // const { fileInputRef: importTroncales, handleImportarTroncales } =
  //   useUploadFile();
  useLoaders(pendingActivacionesRadius)
  return (
    <SingleTableBoxScene
      title="Actualización de Servicio de Cliente"
      // urlRedirect={`${returnUrlActualizarServicioClientePageMain}/crear`}
      // enableRedirect={
      //   true
      // }
        // hasAllPermissions([
        //   ...SAVE_SERVICIO_CLIENTE_PERMISSIONS,
        //   PermissionsEnum.api_add_olt,
        // ])
      //excel
      // enableUploadFile={true}
      // fileInputRef={[importOLTs, importTroncales]}
      // importationName={["Subir OLTs", "Subir Troncales"]}
      // handleFileUpload={[handleImportarOLT, handleImportarTroncales]}
      // enableDownloadFile={true}
      // importationsQuantity={2}
      // urlDownloadPlantilla={[
      //   "/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_OLT,
      //   "/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_OLT_TRONCALES,
      // ]}
      // urlDownloadNameExcel={["plantilla_olt", "plantilla_olt_troncales"]}
      // messageInToolTips={[
      //   "El archivo a importar debe contener una sola hoja y cumplir con el formato indicado en la plantilla.",
      //   "El archivo a importar puede tener una hoja o más. Asegúrese que los nombres de las troncales, host y naps se encuentren en la fila y columna correcta según el formato de la plantilla.",
      // ]}
    >
      <Grid {...gridSizeMdLg12} container item>
        <CustomAutocompleteArrStringNoForm
          label="Tipo de Búsqueda"
          options={CHOICES_TIPOFILTROACTSERVICIOCLIENTE}
          defaultValue={TipoFiltroActServicioCliente.IDENTIFICACION}
          onChangeValue={setTipoFiltro}
          size={gridSizeMdLg3}
        />
      </Grid>
      <CustomSearch 
        onChange={onChangeFilter} 
        value={globalFilter} 
        text={tipoFiltro === TipoFiltroActServicioCliente.IDENTIFICACION ? 'por Identificación' 
          : tipoFiltro === TipoFiltroActServicioCliente.RAZON_SOCIAL ? 'por Razon Social (Apellidos y Nombres)' 
          : ''} 
        cleanFilter={cleanFilter}
        //DESCOMENTAR CUANDO SE SUBA LO DE TICKETS-> S002
        // disabled={!tipoFiltro}
        // inputProps={{
        //   maxLength: tipoFiltro === TipoFiltroActServicioCliente.IDENTIFICACION ? 13 : 250,
        // }}
      />
      {
        Object.keys(rowSelection)?.length>0?
        <Grid {...gridSizeMdLg12} container item spacing={2}>
          <Grid container item {...gridSizeMdLg6} ></Grid>
          <Grid container item {...gridSizeMdLg3} >
            <CustomAutocompleteArrStringNoForm
              label="Estado de Navegación"
              options={ChoicesEstadosNavegacionEnum}
              defaultValue={""}
              size={gridSizeMdLg12}
              onChangeValue={(value)=>{
                setEstadoNavegacionRequerido(value)
              }}
            />
          </Grid>
          <Grid container item {...gridSizeMdLg3} 
            justifyContent={"center"} alignContent={"center"}>
            <Button 
              fullWidth
              variant="contained"
              onClick={async()=>{
                // if(!(dataBulkSelected?.length>0)){
                //   return toast.error("Debe seleccionar un estado de navegación")
                // }
                // if(!estadoNavegacionRequerido){
                //   return toast.error("Debe seleccionar un estado de navegación")
                // }

                await Promise.all(
                  Object.keys(rowSelection)?.map((x:any)=>{
                    updateContrato({
                      id: ClientesMigradosPagingRes?.data?.data?.[x]?.contrato_data?.id_contrato!,
                      data:{
                        estado_navegacion: estadoNavegacionRequerido as EstadosNavegacionEnum
                      }
                    });
                    updateClienteMigrado({
                      id:ClientesMigradosPagingRes?.data?.data?.[x]?.id_cliente_migrado!,
                      data:{
                        estado_servicio: estadoNavegacionRequerido==EstadosNavegacionEnum.ACTIVO?
                         EstadoServicioSoftnet.CLIENTE_ACTIVO:
                         EstadoServicioSoftnet.SERVICIO_SUSPENDIDO
                      }
                    })
                  }
                  )
                ).finally(()=>{
                  setRowSelection({})
                  setEstadoNavegacionRequerido("")
                  setRefetchBulk(true)
                });
              }}>
                CAMBIAR ESTADO DE NAVEGACIÓN
            </Button>
          </Grid>
        </Grid>
        :null
      }
        {/* <Grid container spacing={2} py={2}>
          <Grid container item {...gridSizeMdLg6}>
            <FormControl fullWidth>
              <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={dataBulkSelected?.map(x=>x.razon_social)}
                noOptionsText={"No hay clientes seleccionados"}
                value={dataBulkSelected?.map(x=>x.razon_social)}
                limitTags={3}
                onChange={(event, newValue) =>{
                  if(event){
                    // ===============================================================
                  // Lógica para selección múltiple de clientes desde el multiple select component
                  // ===============================================================
                    setRefetchBulk(true)
                    const dataBulk = [...dataBulkSelected]
                    const withoutDeleted = dataBulk.filter(x=>{
                      if(newValue.includes(x.razon_social)){
                        return x
                      }
                    })
                    setDataBulkSelected(withoutDeleted)
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Clientes Seleccionados"
                    maxRows={3}
                  />
                )}
              />
            </FormControl>
          </Grid>
          
          
        </Grid> */}

      <GeneralTable<ClientesMigrados>
        columns={columns}
        data={ClientesMigradosPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching || refetchBulk}
        enableColumnFilters={false}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={ClientesMigradosPagingRes?.data?.count}
        // // actions ========
        enableColumnActions={true}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={true}
        onEdit={onEdit}
        canDelete={false}

        //custom
        showCustomActionBtnSpace
        enableSelectAll={true}
        enableRowSelection={true}
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
        customActionBtnSpace={(val)=><>
          <SingleIconButton
            startIcon={<Info/>}
            onClick={()=>{
              if(!val.pppoe){
                return toast.error("Cliente no cuenta con PPPoE")
              }
              setCurrentRad(val)
              setopenModalDetailsRReply(true)
            }}
          />
          {
            val.estado_servicio==EstadoServicioSoftnet.CLIENTE_ACTIVO?
            <SingleIconButton 
            startIcon={<SensorsOffIcon/>}
            label="Suspender Servicio"
            onClick={()=>{
              setConfirmDialog({
                isOpen: true,
                subtitle: "¿Está seguro que desea suspender el registro seleccionado?",
                title: "Suspender Navegación",
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  if(!val?.pppoe){
                    return toast.error("No se encontro el username del cliente")
                  }
                  postActivacionesRadius({
                    type_request:"STOP",
                    pppoe:val?.pppoe!
                  },{
                    onSuccess:()=>{
                      CambiarEstadoNavegacion({id: val.contrato_data?.id_contrato!,data:{estado_navegacion:EstadosNavegacionEnum.SUSPENDIDO}})
                      updateClienteMigrado({
                        id:val.id_cliente_migrado!,
                        data:{
                          estado_servicio: EstadoServicioSoftnet.SERVICIO_SUSPENDIDO
                        }
                      })
                      queryClient.invalidateQueries();
                    }
                  })
                },
                onClose() {
                  setConfirmDialogIsOpen(false);
                },
              });
            }}/>
            :<SingleIconButton 
            startIcon={<SensorsIcon/>}
            label="Activar Servicio"
            onClick={()=>{
              setConfirmDialog({
                isOpen: true,
                subtitle: "¿Está seguro que desea activar el registro seleccionado?",
                title: "Activar Navegación",
                onConfirm: async() => {
                  setConfirmDialogIsOpen(false);
                  postActivacionesRadius({
                    type_request:"REACTIVATE",
                    pppoe:val?.pppoe!,
                    ipv4:val?.ipv4!,
                  },{
                    onSuccess:()=>{
                      CambiarEstadoNavegacion({id: val.contrato_data?.id_contrato!,data:{estado_navegacion:EstadosNavegacionEnum.ACTIVO}})
                      updateClienteMigrado({
                        id:val.id_cliente_migrado!,
                        data:{
                          estado_servicio: EstadoServicioSoftnet.CLIENTE_ACTIVO
                        }
                      })
                      queryClient.invalidateQueries();
                    }
                  })
                },
                onClose() {
                  setConfirmDialogIsOpen(false);
                },
              });
            }}/>
          }
          {/* <SampleCheckboxNoForm
            label=""
            defaultValue={ !!(dataBulkSelected?.find(x=>x.id_contrato==val.id_contrato)) || false}
            onChangeValue={(check)=>{
              // ===============================================================
              // Lógica para selección múltiple de clientes
              // ===============================================================
              const dataBulk = [...dataBulkSelected]
              if(check && val?.id_contrato){
                // auxBulk.push(val.id_contrato)
                // setBulkChangeState(auxBulk)
                dataBulk.push({
                  id_contrato:val.id_contrato,
                  razon_social:val?.cliente_data?.razon_social!
                })
                setDataBulkSelected(dataBulk)
              }else{
                const noCurrentDataRow = dataBulk.filter(x=>x.id_contrato!=val.id_contrato)
                setDataBulkSelected(noCurrentDataRow)
              }
            }}
          /> */}
        </>}
        // onDelete={onDelete}
      />
      <DetallesDeConsumoClienteModal
        open={openModalDetailsRReply}
        onClose={()=>{
          setopenModalDetailsRReply(false)
        }}
        username={currentRad?.pppoe||""}
        password={currentRad?.clave_pppoe||""}
      />
    </SingleTableBoxScene>
  );
};

export default ActualizarServicioClientePageMain;
